import { Account } from '../website/Account';

export class Company {

	public id: string;
	public slug: string;
	public aosId?: number;
	public name: string;
	public headquarters: string;
	public aliases: string;
	public description: string;
	public startYear?: number;
	public endYear?: number;
	public isEnabled: boolean;
	public isPopular: boolean;
	public outOfBusiness: boolean;
	public createdDate: string;
	public updatedDate: string;
	public accounts: Account[];

	constructor(init?: Partial<Company>) {
		Object.assign(this, init);
	}

}
